import { Component, Input, OnInit } from '@angular/core';
import { Locale } from 'src/app/model/locale';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-big-image',
  templateUrl: './big-image.component.html',
  styleUrls: ['./big-image.component.scss'],
})
export class BigImageComponent implements OnInit {

  @Input() locale: Locale;

  constructor(private _navigationService: NavigationService) { }

  ngOnInit() { }

  goToVip() {
    this._navigationService.goToPremium(this.locale?.id);
  }

  goToStandard() {
    this._navigationService.goToStandard(this.locale?.id);
  }

  goToApericena() {
    this._navigationService.goToApericena(this.locale?.id);
  }

  get logoUrl() {
    return `assets/${this.locale?.id}/logo.png`;
  }

}
